module.exports = __webpack_public_path__ + "static/img/image1.e8bed1e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/2022/1121/image1.jpeg
// module id = b97B
// module chunks = 38